import { Badge, Tooltip } from '@aecom-ai-engineering/react-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

/** Marks what was generated from the Teams text alone: only its own meeting sees it. */
export const ProvisionalBadge: FC = () => {
  const { t } = useTranslation();

  return (
    <Tooltip content={t('meeting-secretary.meetings.provisional-hint')} side="top">
      {/* Focusable, so the explanation is not for mouse users only. */}
      <Badge
        isRound
        label={t('meeting-secretary.meetings.provisional-label')}
        tabIndex={0}
        variant="outline"
      />
    </Tooltip>
  );
};
